import React, { useState } from "react";
// Import elements from material UI, don't forget to also install @emotion/react and @emotion/styled
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
} from "@mui/material";

export default function AlertDialog() {

  // Change Dialog Title here
  const dialogTitle = "Welcome to CEDR SAFEPATH project website";
  // Change button text within dialog here
  const buttonTextDialogActions = "Continue";

  // Handle display visibilitys of dialog
  const [open, setOpen] = useState(true);

  const handleClose = () => {
    setOpen(false);
  };

  return (
    <div>
      <Dialog
        open={open}
        onClose={handleClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle style={{ textAlign: "left" }} id="alert-dialog-title">
          {dialogTitle}
        </DialogTitle>
        <DialogActions>
          <Button onClick={handleClose} autoFocus aria-label="continue button">
            {buttonTextDialogActions}
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
}
